module.exports = __webpack_public_path__ + "components/country-flag/static/mp-d9756cf02258909674d181847f4f544d.svg";